import React from 'react';
import PropTypes from 'prop-types';
import REQUIRED_FIELDS from '@/pages/events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/states-year/MetricLoader';
import DeltaMetric from '@/pages/states-year/DeltaMetric';
import { site_state_$ilike } from '@/utils/query-helpers';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

StudentsYear.propTypes = {
  state: PropTypes.string,
  network: PropTypes.shape({
    id: PropTypes.number
  }),
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool
};

export default function StudentsYear(props) {
  const { state, schoolStart, schoolEnd, titleOnly } = props;

  const allEvents = usePagedQuery('events', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd
          }
        }
      },
    }
  }, { source: 'states-year/Events/StudentsYear/allEvents', message: STUDENT_IMPACT_MESSAGE });

  const newEvents = usePagedQuery('events', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      },
    }
  }, { source: 'states-year/Events/StudentsYear/newEvents', message: STUDENT_IMPACT_MESSAGE });

  if (
    allEvents.state === PayloadStates.FETCHING ||
    newEvents.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Students Impacted"
      />
    );
  }

  const totalCount = sumActualStudents(allEvents.data);

  const newCount = sumActualStudents(newEvents.data);

  return (
    <DeltaMetric
      name="Students Impacted"
      value={totalCount}
      delta={newCount}
      titleOnly={titleOnly}
    />
  );
}
